import type { OfferVM, FirmVM, ComparatorFilters } from "./types";
import { effectivePrice } from "./derive";

export function sortOffers(
  offers: OfferVM[],
  firms: Map<string, FirmVM>,
  f: ComparatorFilters,
  now: Date = new Date(),
): OfferVM[] {
  const dir = f.sortDir === "asc" ? 1 : -1;
  const value = (o: OfferVM): number | string => {
    switch (f.sortKey) {
      case "price": return effectivePrice(o, now);
      case "rating": return firms.get(o.firmId)?.rating ?? 0;
      case "size": return o.accountSizeK;
      case "activation": return o.activationFeeUsd;
      case "firm": return (firms.get(o.firmId)?.name ?? "").toLowerCase();
    }
  };
  return [...offers].sort((a, b) => {
    const va = value(a);
    const vb = value(b);
    const primary =
      typeof va === "string" && typeof vb === "string"
        ? va.localeCompare(vb) * dir
        : ((va as number) - (vb as number)) * dir;
    // Break ties on offer id so equal-key rows have a stable, predictable order.
    return primary !== 0 ? primary : a.id.localeCompare(b.id);
  });
}
